import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Banner() {
  const [selectedCategory, setSelectedCategory] = useState('')
  const [showPreference, setShowPreference] = useState(true)
  
  return (
    <section className="md:w-[80%] w-[90%] mx-auto flex flex-col md:items-center justify-center mt-[20px] md:mt-0 mb-[30px] h-[80vh]">
      <div className="md:flex hidden items-center justify-center bg-[0A0A0A] gap-1 md:gap-2 rounded">
        <div className="md:w-[8px] md:h-[8px] w-[7px] h-[7px] bg-green-400 text-white rounded-full"></div>
        <h6 className="md:text-sm text-[12px] text-slate-300">
          Featured <span className="hidden md:inline-block">Projects</span>:
        </h6>
        <ul className="flex gap-1 md:gap-2.5 text-[13px] text-[#9D9DA5]">
          <Link to="/project/uiux">
            <li
              onClick={() => setSelectedCategory("uiux")}
              className="md:px-3 px-2 md:text-sm text-[12px] py-1 border border-slate-800 rounded-full cursor-pointer hover:bg-slate-500/10 hover:text-white"
            >
              UI & UX
            </li>
          </Link>

          <Link to="/project/development">
            <li
              onClick={() => setSelectedCategory("frontend")}
              className="md:px-3 px-2 md:text-sm text-[12px] py-1 border border-slate-800 rounded-full cursor-pointer hover:bg-slate-500/10 hover:text-white"
            >
              Frontend
            </li>
          </Link>

          <Link to="/project/development">
            <li className="md:px-3 px-2 md:text-sm text-[12px] py-1 border border-slate-800 rounded-full cursor-pointer hover:bg-slate-700/10 hover:text-white">
              Fullstack
            </li>
          </Link>
        </ul>
      </div>

      {/*--------------TITLE---------- */}
      <div className="md:mt-2 mb-3">
        {/*--------------MOBILE TITLE---------- */}
        <h1 className="text-[36px] leading-[1] md:text-[60px] font-semibold text-[#f1f1f1] text-left mt-3 md:text-center md:hidden">
          Creating interfaces and experiences in the digital realm. Building
          stuff with JavaScript & its ecosystem.
          {/* Designing and Developing w<span className="font-semibold">;</span>th
          Vision */}
        </h1>

        {/*--------------DESKTOP TITLE---------- */}
        <h1 className="text-[32px] leading-[1] md:text-[60px] font-semibold text-[#f4f4f4] text-left mt-3 mb-4 md:text-center hidden md:block">
          Creating interfaces and experiences in the digital realm. Building
          stuff with JavaScript & its ecosystem.
          {/* Designing w<span className="font-semibold">;</span>th Passion,
          <br />
           Developing with Vision. */}
        </h1>
      </div>

      {/*--------------CTA
      <h1 className="md:block hidden text-[24px] text-center md:text-[44px] bg-gradient-to-r from-[#a5a5a5] via-[#fff] inline-block to-[#a5a5a5] text-transparent bg-clip-text ">
        Designing w<span className="font-semibold">;</span>th
        <span className=" font-semibold"> Passion,</span>
      </h1>
      <h1 className="md:block hidden text-[24px] text-center md:text-[44px] bg-gradient-to-r from-[#a5a5a5] via-[#fff] inline-block to-[#a5a5a5] text-transparent bg-clip-text ">
        Developing with
        <span className="text-[#a5a5a5] font-semibold"> Vision.</span>
      </h1>

      {/*--------------CTA---------- */}
      <div className="mt-2 flex md:gap-4 gap-2 text-center md:justify-center">
        <a
          href="https://github.com/amiribnjaman"
          target="_blank"
          className=" flex items-center gap-4 mt-2 md:mt-4 text-center pl-6 pr-3 py-2.5 rounded-full inline-block border border-violet-400/20 bg-slate-500/10 hover:bg-blue-600/80"
        >
          <span className="text-[15px] md:text-[16px]">Github</span>

          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M12 24c6.63 0 12-5.37 12-12S18.63 0 12 0S0 5.37 0 12s5.37 12 12 12M1 12C1 5.92 5.92 1 12 1c6.07 0 11 4.92 11 11c0 4.86-3.15 8.98-7.53 10.4c-.547.109-.747-.237-.747-.528l.005-.614c.005-.568.013-1.42.013-2.41c0-1.04-.346-1.69-.747-2.04c2.46-.273 5.03-1.2 5.03-5.43c0-1.2-.419-2.19-1.13-2.95c.109-.273.492-1.4-.109-2.91c0 0-.93-.291-3.03 1.13a10.6 10.6 0 0 0-2.75-.364c-.93.001-1.86.124-2.75.364c-2.1-1.42-3.03-1.13-3.03-1.13c-.602 1.51-.219 2.64-.11 2.91a4.3 4.3 0 0 0-1.13 2.95c0 4.23 2.57 5.17 5.01 5.43c-.31.273-.602.765-.693 1.48c-.638.292-2.22.765-3.21-.911c0 0-.583-1.06-1.7-1.13c0 0-1.08 0-.073.674c0 0 .729.328 1.22 1.6c0 0 .638 1.97 3.7 1.31c0 .596.008 1.18.013 1.58l.005.463c0 .291-.2.638-.747.528c-4.37-1.46-7.53-5.57-7.53-10.4z"
              clip-rule="evenodd"
            />
          </svg> */}

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 48 48"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M24 2.5a21.5 21.5 0 0 0-6.8 41.9c1.08.2 1.47-.46 1.47-1v-3.65c-6 1.3-7.24-2.88-7.24-2.88A5.7 5.7 0 0 0 9 33.68c-1.95-1.33.15-1.31.15-1.31a4.52 4.52 0 0 1 3.29 2.22c1.92 3.29 5 2.34 6.26 1.79a4.6 4.6 0 0 1 1.37-2.88c-4.78-.54-9.8-2.38-9.8-10.62a8.3 8.3 0 0 1 2.22-5.77a7.68 7.68 0 0 1 .21-5.69s1.8-.58 5.91 2.2a20.46 20.46 0 0 1 10.76 0c4.11-2.78 5.91-2.2 5.91-2.2a7.74 7.74 0 0 1 .21 5.69a8.28 8.28 0 0 1 2.21 5.77c0 8.26-5 10.07-9.81 10.61a5.12 5.12 0 0 1 1.46 4v5.9c0 .71.39 1.24 1.48 1A21.5 21.5 0 0 0 24 2.5"
              stroke-width="2"
            />
          </svg>

          {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="90"
                      height="90"
                      viewBox="0 0 64 64"
                      className="w-7 h-7"
                    >
                      <linearGradient
                        id="KpzH_ttTMIjq8dhx1zD2pa_52539_gr1"
                        x1="30.999"
                        x2="30.999"
                        y1="16"
                        y2="55.342"
                        gradientUnits="userSpaceOnUse"
                        spreadMethod="reflect"
                      >
                        <stop offset="0" stop-color="#6dc7ff"></stop>
                        <stop offset="1" stop-color="#e6abff"></stop>
                      </linearGradient>
                      <path
                        fill="url(#KpzH_ttTMIjq8dhx1zD2pa_52539_gr1)"
                        d="M25.008,56.007c-0.003-0.368-0.006-1.962-0.009-3.454l-0.003-1.55 c-6.729,0.915-8.358-3.78-8.376-3.83c-0.934-2.368-2.211-3.045-2.266-3.073l-0.124-0.072c-0.463-0.316-1.691-1.157-1.342-2.263 c0.315-0.997,1.536-1.1,2.091-1.082c3.074,0.215,4.63,2.978,4.694,3.095c1.569,2.689,3.964,2.411,5.509,1.844 c0.144-0.688,0.367-1.32,0.659-1.878C20.885,42.865,15.27,40.229,15.27,30.64c0-2.633,0.82-4.96,2.441-6.929 c-0.362-1.206-0.774-3.666,0.446-6.765l0.174-0.442l0.452-0.144c0.416-0.137,2.688-0.624,7.359,2.433 c1.928-0.494,3.969-0.749,6.074-0.759c2.115,0.01,4.158,0.265,6.09,0.759c4.667-3.058,6.934-2.565,7.351-2.433l0.451,0.145 l0.174,0.44c1.225,3.098,0.813,5.559,0.451,6.766c1.618,1.963,2.438,4.291,2.438,6.929c0,9.591-5.621,12.219-10.588,13.087 c0.563,1.065,0.868,2.402,0.868,3.878c0,1.683-0.007,7.204-0.015,8.402l-2-0.014c0.008-1.196,0.015-6.708,0.015-8.389 c0-2.442-0.943-3.522-1.35-3.874l-1.73-1.497l2.274-0.253c5.205-0.578,10.525-2.379,10.525-11.341c0-2.33-0.777-4.361-2.31-6.036 l-0.43-0.469l0.242-0.587c0.166-0.401,0.894-2.442-0.043-5.291c-0.758,0.045-2.568,0.402-5.584,2.447l-0.384,0.259l-0.445-0.123 c-1.863-0.518-3.938-0.796-6.001-0.806c-2.052,0.01-4.124,0.288-5.984,0.806l-0.445,0.123l-0.383-0.259 c-3.019-2.044-4.833-2.404-5.594-2.449c-0.935,2.851-0.206,4.892-0.04,5.293l0.242,0.587l-0.429,0.469 c-1.536,1.681-2.314,3.712-2.314,6.036c0,8.958,5.31,10.77,10.504,11.361l2.252,0.256l-1.708,1.49 c-0.372,0.325-1.03,1.112-1.254,2.727l-0.075,0.549l-0.506,0.227c-1.321,0.592-5.839,2.162-8.548-2.485 c-0.015-0.025-0.544-0.945-1.502-1.557c0.646,0.639,1.433,1.673,2.068,3.287c0.066,0.19,1.357,3.622,7.28,2.339l1.206-0.262 l0.012,3.978c0.003,1.487,0.006,3.076,0.009,3.444L25.008,56.007z"
                      ></path>
                      <linearGradient
                        id="KpzH_ttTMIjq8dhx1zD2pb_52539_gr2"
                        x1="32"
                        x2="32"
                        y1="5"
                        y2="59.167"
                        gradientUnits="userSpaceOnUse"
                        spreadMethod="reflect"
                      >
                        <stop offset="0" stop-color="#1a6dff"></stop>
                        <stop offset="1" stop-color="#c822ff"></stop>
                      </linearGradient>
                      <path
                        fill="url(#KpzH_ttTMIjq8dhx1zD2pb_52539_gr2)"
                        d="M32,58C17.663,58,6,46.337,6,32S17.663,6,32,6s26,11.663,26,26S46.337,58,32,58z M32,8 C18.767,8,8,18.767,8,32s10.767,24,24,24s24-10.767,24-24S45.233,8,32,8z"
                      ></path>
                    </svg> */}
        </a>

        <a
          href="https://drive.google.com/file/d/1EM-0RoKZoxV4Xx1CTyCCr3c2Z69CfsNy/view"
          target="_blank"
          className="flex items-center gap-4 mt-2 md:mt-4 text-center pl-6 pr-2 py-2.5 rounded-full inline-block border border-violet-400/20 bg-slate-500/10 hover:bg-blue-600/80"
        >
          Download Resume
          <span className="w-[26px] h-[26px] flex items-center justify-center bg-white rounded-full text-black">
            <svg
              className="rotate-45"
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="m12.354 5.646l5 5a.5.5 0 0 1-.708.708L12.5 7.207V18a.5.5 0 0 1-1 0V7.207l-4.146 4.147a.5.5 0 0 1-.708-.708l5-5a.5.5 0 0 1 .708 0"
              />
            </svg>
          </span>
        </a>
      </div>

      {/* POPUP */}
      {showPreference && (
        <div
          className={`absolute hidden right-[5%] md:right-[10%] bottom-[3%] md:bottom-[5%] z-50 w-[300px] md:w-[350px] h-[128px] border-slate-700 px-4 py-3 text-[#DEDEDE] bg-gradient-to-r from-slate-500/10 to-slate-500/20 via-slate-500/20 rounded-lg text-[#9F9FA8]`}
        >
          {/* <h4 className="text-[14px] md:text-[16px] text-white mt-6 font-semibold">
            Select the area of preferences
          </h4> */}
          <button
            onClick={() => setShowPreference(!showPreference)}
            className="bg-slate-600/30 absolute top-0 right-0 px-4 py-1.5 rounded-tr-lg text-[14px] rounded-bl-lg text-center"
          >
            Skip
          </button>
          <div>
            <div className="">
              <h4 className="text-[14px] w-[80%] md:text-[16px] text-slate-50 font-regular">
                Focus on the expertise you're most interested in reviewing..
              </h4>
            </div>

            {/*------PROJECT LIVE LINKS BUTTONS----- */}
            {/*------PROJECT LIVE LINKS BUTTONS----- */}
            <div className="flex gap-2">
              <div className="mt-5 rounded">
                <ul className="flex gap-2.5 text-[13px] text-[#9D9DA5]">
                  <li
                    onClick={() => setSelectedCategory("uiux")}
                    className="px-3 md:px-4 bg-[#0f172a] py-1.5 border border-slate-700 rounded-full cursor-pointer text-white hover:bg-blue-600/80 hover:text-white"
                  >
                    <Link
                      to="/project/uiux"
                      className="flex gap-2 items-center"
                    >
                      <span>UI & UX</span>
                      <span>
                        <svg
                          className="rotate-90 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="m12.354 5.646l5 5a.5.5 0 0 1-.708.708L12.5 7.207V18a.5.5 0 0 1-1 0V7.207l-4.146 4.147a.5.5 0 0 1-.708-.708l5-5a.5.5 0 0 1 .708 0"
                          />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li
                    onClick={() => setSelectedCategory("frontend")}
                    className="px-3 md:px-4 bg-[#0f172a] py-1.5 border border-slate-700 rounded-full text-white cursor-pointer hover:bg-blue-600/80 hover:text-white"
                  >
                    <Link
                      to="/project/development"
                      className="flex gap-2 items-center"
                    >
                      <span>Development</span>
                      <span>
                        <svg
                          className="rotate-90 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="m12.354 5.646l5 5a.5.5 0 0 1-.708.708L12.5 7.207V18a.5.5 0 0 1-1 0V7.207l-4.146 4.147a.5.5 0 0 1-.708-.708l5-5a.5.5 0 0 1 .708 0"
                          />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  {/* <li
                    onClick={() => setShowPreference(!showPreference)}
                    className="px-4 py-1.5 underline underline-slate-700 rounded-full cursor-pointer hover:bg-slate-700/10 hover:text-white"
                  >
                    <Link to='' >Stay & explore</Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
